import React, { Component } from "react";
import PropTypes from "prop-types";
import shop from "../../../api/shop";
import { connect } from "react-redux";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import { store } from "../../../main.js";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  Progress
} from "reactstrap";
import { loadingSales, storeSales } from "../../../store/common";
import { RingLoader } from "react-spinners";

class SalesContainer extends Component {
  componentWillMount = () => {
    store.dispatch(loadingSales(true));
    shop.getSales(salesPromise => {
      salesPromise.then(sales => {
        console.log(sales);
        store.dispatch(storeSales(sales));
        store.dispatch(loadingSales(false));
      });
    });
  };

  render() {
    return (
      <div>
        <h1>{this.props.translate("routes.sales.title")}</h1>
        {!this.props.isSalesLoading &&
        this.props.sales &&
        this.props.sales.length > 0 ? (
          <ListGroup>
            <ListGroupItem>
              <ListGroupItemHeading className="d-flex justify-content-between">
                <div className="w-25">
                  {this.props.translate(
                    "routes.productList.summaryContainer.open_order_unavailable_flex"
                  )}
                </div>
                <div className="w-25">
                  {this.props.translate(
                    "routes.productList.summaryContainer.open_order_unavailable_code"
                  )}
                </div>
                <div className="w-5">
                  {this.props.translate("routes.sales.target")}
                </div>
                <div className="w-5">
                  {this.props.translate("routes.sales.sold")}
                </div>
                <div className="w-25" />
              </ListGroupItemHeading>
            </ListGroupItem>
            {this.props.sales.map(s => (
              <ListGroupItem
                key={s.id}
                className="d-flex justify-content-between"
              >
                {/* <div>{s}</div> */}
                <div className="w-25">
                  {s.product.texts[this.props.currentLanguageId - 1].flex_name}
                </div>
                <div className="w-25">{s.product.code}</div>
                <div className="w-5">{s.target}</div>
                <div className="w-5">{s.sold}</div>
                <div className="w-25">
                  {/* <div className="text-center">
                    {parseFloat((s.sold * 100) / s.target).toFixed(2)} %
                  </div> */}
                  <Progress value={(s.sold * 100) / s.target}>
                    {parseFloat((s.sold * 100) / s.target).toFixed(2)} %
                  </Progress>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        ) : (
          <div className="spinner">
            <RingLoader
              color={"#d42e2b"}
              loading={this.props.isSalesLoading}
              size={120}
              margin={20}
            />
          </div>
        )}
      </div>
    );
  }
}

SalesContainer.propTypes = {
  translate: PropTypes.func
};

const mapStateToProps = ({ common, locale }) => ({
  translate: getTranslate(locale),
  isSalesLoading: common.salesLoading,
  sales: common.sales,
  currentLanguageId: getActiveLanguage(locale).id
});

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesContainer);



// WEBPACK FOOTER //
// ./src/routes/Sales/containers/SalesContainer.js